import { types } from './types';

export const logout = ({ revokeSession } = {}) => {
  return ({
    type: types.AUTH_LOG_OUT_REQUEST,
    payload: revokeSession,
  });
};

export const refresh = () => ({
  type: types.AUTH_REFRESH_REQUEST,
});
